import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";

export const Tooltip = ({ children, content, title }) => {
	const [isVisible, setIsVisible] = useState(false);

	return (
		<div
			className="md:relative md:inline-block"
			onMouseEnter={() => setIsVisible(true)}
			onMouseLeave={() => setIsVisible(false)}
			onTouchStart={() => setIsVisible(!isVisible)}
		>
			{children}
			<AnimatePresence>
				{isVisible && (
					<motion.div
						initial={{ opacity: 0, y: 5 }}
						animate={{ opacity: 1, y: 0 }}
						exit={{ opacity: 0, y: 5 }}
						className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-[350px] md:w-64 p-3 bg-[#000]/80 text-white text-sm rounded-lg z-50"
					>
						<h4 className="font-medium mb-1">{title}</h4>
						<p className="text-gray-300">{content}</p>
						<div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 rotate-45 w-2 h-2 bg-[#000]/80" />
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	);
};
